import { apiSlice } from './apiSlice';
import { ORDERS_URL } from '../constants';

// NOTE: the bearer token is now attached centrally by apiSlice's prepareHeaders
// (read per-request from localStorage), so individual endpoints no longer set
// Authorization headers themselves.

export const ordersApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    createOrder: builder.mutation({
      query: (order) => ({
        url: ORDERS_URL,
        method: 'POST',
        body: { ...order },
      }),
    }),
    createGuestOrder: builder.mutation({
      query: (order) => ({
        url: `${ORDERS_URL}/guest`,
        method: 'POST',
        body: { ...order },
      }),
    }),
    payOrder: builder.mutation({
      query: (order) => ({
        url: `${ORDERS_URL}/payment`,
        method: 'POST',
        body: { ...order },
      }),
    }),
    confirmOrder: builder.mutation({
      query: (order) => ({
        url: `${ORDERS_URL}/confirm`,
        method: 'POST',
        body: { ...order },
      }),
    }),
    verifyPayment: builder.mutation({
      query: (data) => ({
        url: '/api/payments/verify',
        method: 'POST',
        body: data,
      }),
    }),
    uploadOrder: builder.mutation({
      query: (order) => ({
        url: `${ORDERS_URL}/image/upload`,
        method: 'POST',
        body: { ...order },
      }),
    }),
    getOrderDetails: builder.query({
      query: (id) => ({
        url: `${ORDERS_URL}/${id}`,
      }),
      keepUnusedDataFor: 5,
    }),
    getMyOrders: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/profile/mine`,
      }),
      keepUnusedDataFor: 5,
    }),
    getOrders: builder.query({
      query: () => ({
        url: ORDERS_URL,
      }),
      keepUnusedDataFor: 5,
    }),
    getReceipts: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/admin/receipts`,
      }),
      keepUnusedDataFor: 5,
    }),
    getContacts: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/admin/contacts`,
      }),
      keepUnusedDataFor: 5,
    }),
    getLetters: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/admin/newsletters`,
      }),
      keepUnusedDataFor: 5,
    }),
    getShippments: builder.query({
      query: () => ({
        url: `${ORDERS_URL}/admin/shippments`,
      }),
      keepUnusedDataFor: 5,
    }),
    makeShippment: builder.mutation({
      query: (order) => ({
        url: `${ORDERS_URL}/admin/make-shippment`,
        method: 'POST',
        body: { ...order },
      }),
    }),

    // --- Fulfillment handoff ---
    getFulfillmentQueue: builder.query({
      query: () => ({
        url: '/api/fulfillment/queue',
      }),
      providesTags: ['Fulfillment'],
      keepUnusedDataFor: 5,
    }),
    markShipped: builder.mutation({
      query: (data) => ({
        url: '/api/fulfillment/ship',
        method: 'POST',
        body: data, // { order_id, carrier, awb }
      }),
      invalidatesTags: ['Fulfillment'],
    }),
    markDelivered: builder.mutation({
      query: (data) => ({
        url: '/api/fulfillment/delivered',
        method: 'POST',
        body: data, // { order_id }
      }),
      invalidatesTags: ['Fulfillment'],
    }),
  }),
});

export const {
  useGetShippmentsQuery,
  useMakeShippmentMutation,
  useGetContactsQuery,
  useGetLettersQuery,
  useGetReceiptsQuery,
  useGetOrdersQuery,
  useCreateOrderMutation,
  useCreateGuestOrderMutation,
  useConfirmOrderMutation,
  useVerifyPaymentMutation,
  usePayOrderMutation,
  useUploadOrderMutation,
  useGetOrderDetailsQuery,
  useGetMyOrdersQuery,
  useGetFulfillmentQueueQuery,
  useMarkShippedMutation,
  useMarkDeliveredMutation,
} = ordersApiSlice;
